export default {
  name: "view",
  class: "h-6 w-6",
  box: 24,
  svg: " <path  stroke-linecap='round'  stroke='fillcolor'  stroke-width='2'  stroke-linejoin='round'  d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'  />  <path  stroke-linecap='round' stroke='fillcolor' stroke-width='2' stroke-linejoin='round'  d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'  />",
};
